// extracted by mini-css-extract-plugin
module.exports = {"container":"k_c","cookies":"k_H","trigger":"k_J"};